/**
 * Éclat Luxury Jewelry - Atelier Shortlist & Wishlist Engine
 */
class AtelierWishlist {
  constructor() {
    this.storageKey = 'eclat_atelier_wishlist';
    this.items = this.loadItems();
    this.drawer = document.getElementById('WishlistDrawer');
    this.overlay = document.querySelector('.wishlist-drawer-overlay');
    this.init();
  }

  loadItems() {
    try {
      const data = localStorage.getItem(this.storageKey);
      return data ? JSON.parse(data) : [];
    } catch (e) {
      return [];
    }
  }

  saveItems() {
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(this.items));
      this.updateBadges();
      this.renderDrawer();
    } catch (e) {
      console.error(e);
    }
  }

  init() {
    this.updateBadges();
    this.renderDrawer();
    this.bindEvents();
  }

  toggleItem(product) {
    const index = this.items.findIndex(i => i.id === product.id || i.handle === product.handle);
    if (index > -1) {
      this.items.splice(index, 1);
    } else {
      this.items.push(product);
    }
    this.saveItems();
    this.updateButtons();
  }

  isInWishlist(idOrHandle) {
    return this.items.some(i => i.id === idOrHandle || i.handle === idOrHandle);
  }

  updateBadges() {
    const count = this.items.length;
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'inline-flex' : 'none';
    });
    const headerCount = document.querySelector('[data-wishlist-count-header]');
    if (headerCount) headerCount.textContent = count;
  }

  updateButtons() {
    document.querySelectorAll('[data-wishlist-btn]').forEach(btn => {
      const handle = btn.dataset.productHandle || btn.dataset.productId;
      const isSaved = this.isInWishlist(handle);
      btn.classList.toggle('is-saved', isSaved);
      btn.setAttribute('aria-pressed', isSaved ? 'true' : 'false');
    });
  }

  openDrawer() {
    if (!this.drawer) return;
    this.renderDrawer();
    this.drawer.classList.add('is-open');
    this.drawer.setAttribute('aria-hidden', 'false');
    if (this.overlay) this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  closeDrawer() {
    if (!this.drawer) return;
    this.drawer.classList.remove('is-open');
    this.drawer.setAttribute('aria-hidden', 'true');
    if (this.overlay) this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  renderDrawer() {
    if (!this.drawer) return;
    const listEl = this.drawer.querySelector('[data-wishlist-items-list]');
    const emptyEl = this.drawer.querySelector('[data-wishlist-empty]');
    if (!listEl) return;

    if (this.items.length === 0) {
      listEl.innerHTML = '';
      if (emptyEl) emptyEl.style.display = 'block';
      return;
    }

    if (emptyEl) emptyEl.style.display = 'none';

    listEl.innerHTML = this.items.map(item => `
      <div class="wishlist-item-card" data-item-handle="${item.handle || item.id}">
        <a href="${item.url}" class="wishlist-item-image" onclick="if (window.openPdpProduct) { event.preventDefault(); window.EclatWishlist.closeDrawer(); window.openPdpProduct('${item.title.replace(/'/g, "\\'")}'); }">
          <img src="${item.image}" alt="${item.title}">
        </a>
        <div class="wishlist-item-details">
          <a href="${item.url}" class="wishlist-item-title" onclick="if (window.openPdpProduct) { event.preventDefault(); window.EclatWishlist.closeDrawer(); window.openPdpProduct('${item.title.replace(/'/g, "\\'")}'); }">${item.title}</a>
          <div class="wishlist-item-price">${item.price}</div>
          <div class="wishlist-item-actions">
            <button type="button" class="btn-luxury" style="padding: 6px 14px; font-size: 0.6875rem;" onclick="if (window.openPdpProduct) { window.EclatWishlist.closeDrawer(); window.openPdpProduct('${item.title.replace(/'/g, "\\'")}'); } else if (window.EclatQuickAdd && window.EclatQuickAdd.openModal) { window.EclatQuickAdd.openModal('${item.handle}'); } else { window.location.href='${item.url}'; }">
              Acquire Piece
            </button>
            <button type="button" class="wishlist-remove-btn" data-remove-wishlist="${item.handle || item.id}">
              Remove
            </button>
          </div>
        </div>
      </div>
    `).join('');

    listEl.querySelectorAll('[data-remove-wishlist]').forEach(btn => {
      btn.addEventListener('click', () => {
        const handle = btn.dataset.removeWishlist;
        this.items = this.items.filter(i => (i.handle || i.id) !== handle);
        this.saveItems();
        this.updateButtons();
      });
    });
  }

  bindEvents() {
    document.addEventListener('click', (e) => {
      const toggleBtn = e.target.closest('[data-wishlist-btn]');
      if (toggleBtn) {
        e.preventDefault();
        e.stopPropagation();
        const product = {
          id: toggleBtn.dataset.productId || '',
          handle: toggleBtn.dataset.productHandle || '',
          title: toggleBtn.dataset.productTitle || 'Jewelry Piece',
          price: toggleBtn.dataset.productPrice || '$0.00',
          image: toggleBtn.dataset.productImage || '',
          url: toggleBtn.dataset.productUrl || '/products/' + (toggleBtn.dataset.productHandle || '')
        };
        this.toggleItem(product);
        return;
      }

      const openTrigger = e.target.closest('[data-open-wishlist]');
      if (openTrigger) {
        e.preventDefault();
        this.openDrawer();
        return;
      }

      const closeTrigger = e.target.closest('[data-close-wishlist]');
      if (closeTrigger) {
        e.preventDefault();
        this.closeDrawer();
        return;
      }
    });

    this.updateButtons();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.EclatWishlist = new AtelierWishlist();
});
